import React, { memo } from 'react'
import { withStyles } from '@material-ui/core/styles'

import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator'

import PeriodsFilter from './PeriodsFilter'
import DateSessionFilter from './DateSessionFilter'

import UserIcon from 'Assets/Images/icons/user'
import ShareIcon from 'Assets/Images/icons/share'
import MailIcon from 'Assets/Images/icons/mail'

import style from './style'

function ColumnHeader({
  count,
  classes,
  exportColumn,
  onMailClick,
  setFiltered,
  name,
  isLoading = false,
  items,
}) {
  const periodsFilterTitle = () => {
    if (name === 'interested') {
      return 'Signup date'
    }
    if (name === 'videoOnboarding') {
      return 'Date since signup'
    }
    if (name === 'test') {
      return 'Date since onboarding'
    }
    if (name === 'refused') {
      return 'Date since signup'
    }
    if (name === 'preAccess') {
      return 'Date since onboarding'
    }
    if (name === 'finalReview') {
      return 'Date since onboarding'
    }
    if (name === 'onsiteMeeting') {
      return 'Date since review'
    }
    if (name === 'approved') {
      return 'Date since the approval'
    }
  }

  const titleMap = {
    uninterested: 'UNINTERESTED',
    interested: 'INTERESTED',
    booked: 'BOOKED',
    videoOnboarding: 'Video Onboarding',
    test: 'TEST',
    refused: 'BLOCKED',
    onSiteTraining: 'ONSITE TRAINING',
    preAccess: 'PRE ACCESS',
    finalReview: 'WAITING FOR REVIEW',
    onsiteMeeting: 'ONSITE MEETING',
    approved: 'APPROVED',
  }

  return (
    <div className={classes.header} cypress_id={`ambsColumnHeader`}>
      <div className={classes.top} cypress_id={`columnName-${name}`}>
        <div className={classes.buttons}>
          {// TODO: remove this condition when other stages have triggers
          ['interested', 'booked', 'approved'].includes(name) && (
            <span onClick={() => onMailClick(name)} className={classes.mail}>
              <MailIcon height="14px" />
            </span>
          )}
          <span onClick={exportColumn} className={classes.share}>
            <ShareIcon height="14px" />
          </span>
        </div>
        <span className={classes.title}>{titleMap[name]}</span>
        <span className={classes.count}>
          <UserIcon height="14px" />
          {isLoading ? (
            <span className={classes.countIndicatorWrapper}>
              <LoadingIndicator
                label=""
                size="10px"
                style={{ padding: '0px', height: 'auto' }}
              />
            </span>
          ) : (
            count
          )}
        </span>
      </div>
      <div className={classes.content}>
        {name !== 'booked' && (
          <PeriodsFilter
            title={periodsFilterTitle}
            onChange={setFiltered}
            items={items}
            columnName={name}
          />
        )}
        {name === 'booked' && (
          <DateSessionFilter onChange={setFiltered} items={items} />
        )}
      </div>
    </div>
  )
}

export default memo(withStyles(style)(ColumnHeader))
